import {
  GetShiftPlanningShiftsResponse,
  ShiftPlanningBusinessUnitsData,
  ShiftPlanningJobTypesData,
  ShiftPlanningParams,
} from './shift-planning-service.types';
import { HqApiService } from './hqApiService';

class ShiftPlanningService {
  constructor(private readonly hqApiService: HqApiService) {}

  public async getShiftPlanningShifts({
    fromDate,
    company,
    branchOfficeIds,
    departmentIds,
    pageParam,
    pageSizeParam,
    jobType,
    filledStatus,
    isFreelance,
    isTempWork,
    isEmployee,
    areFreelanceApplications,
    areTempworkApplications,
    areNoApplications,
  }: ShiftPlanningParams) {
    const response = await this.hqApiService.get<GetShiftPlanningShiftsResponse>({
      params: {
        page: pageParam,
        pageSize: pageSizeParam,
        fromDate: fromDate?.toISO(),
        companyId: company,
        branchOffices: branchOfficeIds,
        departments: departmentIds,
        jobType: jobType,
        filledStatus,
        isFreelance,
        isTempWork,
        areFreelanceApplications,
        areTempworkApplications,
        areNoApplications,
        isEmployee,
      },
      path: 'shift-planning/shifts',
    });

    return response;
  }

  public async getShiftPlanningBusinessUnitsData() {
    const response = await this.hqApiService.get<ShiftPlanningBusinessUnitsData>({
      path: 'shift-planning/business-units',
    });

    return response;
  }

  public async getShiftPlanningJobTypesData() {
    const response = await this.hqApiService.get<ShiftPlanningJobTypesData>({
      path: 'shift-planning/job-types',
    });
    return response;
  }
}

export { ShiftPlanningService };
